export const DEFAULT_MEASURE_SCALE = 32;

export const dist = (x1, y1, x2, y2) => Math.hypot(x2 - x1, y2 - y1);

export const toMm = (units, scale = DEFAULT_MEASURE_SCALE) =>
  Math.round(units * scale);

export const fmtMm = (mm) => String(mm).replace(/\B(?=(\d{3})+(?!\d))/g, " ");

export const measureLabel = (x1, y1, x2, y2, scale = DEFAULT_MEASURE_SCALE) =>
  fmtMm(toMm(dist(x1, y1, x2, y2), scale));

export const scaleFromReference = (pdfDistance, knownMm) => {
  if (!pdfDistance || !knownMm || pdfDistance <= 0) return null;
  return knownMm / pdfDistance;
};

export const smoothPath = (points) => {
  if (!points || points.length < 2) {
    return points?.length ? `M${points[0].x} ${points[0].y} l0.1 0.1` : "";
  }

  let d = `M ${points[0].x} ${points[0].y}`;
  for (let i = 1; i < points.length - 1; i += 1) {
    const mx = (points[i].x + points[i + 1].x) / 2;
    const my = (points[i].y + points[i + 1].y) / 2;
    d += ` Q ${points[i].x} ${points[i].y} ${mx} ${my}`;
  }
  const last = points[points.length - 1];
  d += ` L ${last.x} ${last.y}`;
  return d;
};

export const parsePathData = (pathData) => {
  if (!pathData) return [];
  try {
    const parsed = JSON.parse(pathData);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const absolutePathPoints = (module) => {
  const points = parsePathData(module.path_data);
  const ox = parseFloat(module.x_position) || 0;
  const oy = parseFloat(module.y_position) || 0;
  return points.map((point) => ({
    x: ox + (parseFloat(point.x) || 0),
    y: oy + (parseFloat(point.y) || 0),
  }));
};

export const normalizePenPath = (points) => {
  if (!points.length) return null;

  const xs = points.map((p) => p.x);
  const ys = points.map((p) => p.y);
  const minX = Math.min(...xs);
  const minY = Math.min(...ys);

  return {
    x_position: minX,
    y_position: minY,
    width: Math.max(...xs) - minX,
    height: Math.max(...ys) - minY,
    path_data: JSON.stringify(
      points.map((point) => ({
        x: point.x - minX,
        y: point.y - minY,
      }))
    ),
  };
};

export const isModuleHitTarget = (target) =>
  target?.closest?.("[data-module-hit]");

export const deviationStatusLabel = (status, t) => {
  switch (String(status)) {
    case "1":
      return t("drawings.viewer.deviation_status.open");
    case "2":
      return t("drawings.viewer.deviation_status.in_progress");
    case "3":
      return t("drawings.viewer.deviation_status.closed");
    default:
      return t("drawings.viewer.deviation_status.unknown");
  }
};

export const checklistItemStatus = (item) => {
  if (item.isApproved) return "approved";
  if (item.isDeviation) return "deviation";
  if (item.is_not_applicable) return "na";
  return "pending";
};
